import { useCallback } from "react";
function useClickAwayProps(dispatch) {
  const onClickAway = useCallback(() => {
    dispatch({ type: "clickAway:click" });
  }, [dispatch]);
  return {
    onClickAway
  };
}
export {
  useClickAwayProps
};
//# sourceMappingURL=useClickAwayProps.js.map
